module.exports = __webpack_public_path__ + "static/img/TMBcharacterPhotos_0000_mrNancy.6b755be.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/TMBcharacterPhotos_0000_mrNancy.jpg
// module id = JnzX
// module chunks = 1